import { API_REFETCH_TIME } from '@containers/dashboard/options';
import { dashboardDivisionAsonCentersApiHandler } from '@helpers/dashboardApiHelpers';
import { AllDivisionCenters, AllDivisionCentersLoading } from '@type/dashboard';
import { useCallback, useEffect, useState } from 'react';

interface useDashboardDivisionCentersType {
  dashboardCenters: AllDivisionCenters | null;
  isLoading: AllDivisionCentersLoading;
  handleQuery: (
    divisionId: number,
    asonId: number,
    election_schedule_id: string,
  ) => void;
}

export const useDashboardDivisionCenters =
  (): useDashboardDivisionCentersType => {
    const [dashboardCenters, setDashboardCenters] =
      useState<AllDivisionCenters>([
        {
          divisionId: 2,
          division: 'ঢাকা',
          division_en: 'DHAKA',
          election_settings: '',
          centers: [],
          election_settings_id: null,
          centers_info: [],
        },
        {
          divisionId: 3,
          division: 'চট্টগ্রাম',
          division_en: 'CHATTOGRAM',
          election_settings: '',
          centers: [],
          election_settings_id: null,
          centers_info: [],
        },
        {
          divisionId: 5,
          division: 'খুলনা',
          division_en: 'KHULNA',
          election_settings: '',
          centers: [],
          election_settings_id: null,
          centers_info: [],
        },
        {
          divisionId: 7,
          division: 'সিলেট',
          division_en: 'SYLHET',
          election_settings: '',
          centers: [],
          election_settings_id: null,
          centers_info: [],
        },
        {
          divisionId: 9,
          division: 'ময়মনসিংহ',
          division_en: 'MYMENSINGH',
          election_settings: '',
          centers: [],
          election_settings_id: null,
          centers_info: [],
        },
        {
          divisionId: 4,
          division: 'রাজশাহী',
          division_en: 'RAJSHAHI',
          election_settings: '',
          centers: [],
          election_settings_id: null,
          centers_info: [],
        },
        {
          divisionId: 8,
          division: 'রংপুর',
          division_en: 'RANGPUR',
          election_settings: '',
          centers: [],
          election_settings_id: null,
          centers_info: [],
        },
        {
          divisionId: 6,
          division: 'বরিশাল',
          division_en: 'BARISHAL',
          election_settings: '',
          centers: [],
          election_settings_id: null,
          centers_info: [],
        },
      ]);

    const [isLoading, setIsLoading] = useState<AllDivisionCentersLoading>([
      { divisionId: 2, loading: false },
      { divisionId: 3, loading: false },
      { divisionId: 4, loading: false },
      { divisionId: 5, loading: false },
      { divisionId: 6, loading: false },
      { divisionId: 7, loading: false },
      { divisionId: 8, loading: false },
      { divisionId: 9, loading: false },
    ]);

    const [apiRefetch, setApiRefetch] = useState<boolean>(false);

    const [dhakaDivisionQuery, setDhakaDivisionQuery] = useState<{
      divisionId: number;
      asonId: number;
      election_schedule_id: string;
    }>({
      divisionId: 0,
      asonId: 0,
      election_schedule_id: '',
    });

    const [chattogramDivisionQuery, setChattogramDivisionQuery] = useState<{
      divisionId: number;
      asonId: number;
      election_schedule_id: string;
    }>({
      divisionId: 0,
      asonId: 0,
      election_schedule_id: '',
    });

    const [khulnaDivisionQuery, setKhulnaDivisionQuery] = useState<{
      divisionId: number;
      asonId: number;
      election_schedule_id: string;
    }>({
      divisionId: 0,
      asonId: 0,
      election_schedule_id: '',
    });

    const [sylhetDivisionQuery, setSylhetDivisionQuery] = useState<{
      divisionId: number;
      asonId: number;
      election_schedule_id: string;
    }>({
      divisionId: 0,
      asonId: 0,
      election_schedule_id: '',
    });

    const [mymensinghDivisionQuery, setMymensinghDivisionQuery] = useState<{
      divisionId: number;
      asonId: number;
      election_schedule_id: string;
    }>({
      divisionId: 0,
      asonId: 0,
      election_schedule_id: '',
    });

    const [rajshahiDivisionQuery, setRajshahiDivisionQuery] = useState<{
      divisionId: number;
      asonId: number;
      election_schedule_id: string;
    }>({
      divisionId: 0,
      asonId: 0,
      election_schedule_id: '',
    });

    const [rangpurDivisionQuery, setRangpurDivisionQuery] = useState<{
      divisionId: number;
      asonId: number;
      election_schedule_id: string;
    }>({
      divisionId: 0,
      asonId: 0,
      election_schedule_id: '',
    });

    const [barishalDivisionQuery, setBarishalDivisionQuery] = useState<{
      divisionId: number;
      asonId: number;
      election_schedule_id: string;
    }>({
      divisionId: 0,
      asonId: 0,
      election_schedule_id: '',
    });

    const handleQuery = (
      divisionId: number,
      asonId: number,
      election_schedule_id: string,
    ) => {
      if (divisionId === 2) {
        setDhakaDivisionQuery({
          divisionId: divisionId,
          asonId: asonId,
          election_schedule_id: election_schedule_id,
        });
      } else if (divisionId === 3) {
        setChattogramDivisionQuery({
          divisionId: divisionId,
          asonId: asonId,
          election_schedule_id: election_schedule_id,
        });
      } else if (divisionId === 4) {
        setRajshahiDivisionQuery({
          divisionId: divisionId,
          asonId: asonId,
          election_schedule_id: election_schedule_id,
        });
      } else if (divisionId === 5) {
        setKhulnaDivisionQuery({
          divisionId: divisionId,
          asonId: asonId,
          election_schedule_id: election_schedule_id,
        });
      } else if (divisionId === 6) {
        setBarishalDivisionQuery({
          divisionId: divisionId,
          asonId: asonId,
          election_schedule_id: election_schedule_id,
        });
      } else if (divisionId === 7) {
        setSylhetDivisionQuery({
          divisionId: divisionId,
          asonId: asonId,
          election_schedule_id: election_schedule_id,
        });
      } else if (divisionId === 8) {
        setRangpurDivisionQuery({
          divisionId: divisionId,
          asonId: asonId,
          election_schedule_id: election_schedule_id,
        });
      } else if (divisionId === 9) {
        setMymensinghDivisionQuery({
          divisionId: divisionId,
          asonId: asonId,
          election_schedule_id: election_schedule_id,
        });
      } else {
        // console.log("nothing to do")
      }
    };

    const cacheHandleQuery = useCallback(handleQuery, []);

    useEffect(() => {
      if (dhakaDivisionQuery.asonId && dhakaDivisionQuery.divisionId) {
        dashboardDivisionAsonCentersApiHandler(
          dhakaDivisionQuery,
          setIsLoading,
          setDashboardCenters,
        );
      }
    }, [apiRefetch, dhakaDivisionQuery]);

    useEffect(() => {
      if (
        chattogramDivisionQuery.asonId &&
        chattogramDivisionQuery.divisionId
      ) {
        dashboardDivisionAsonCentersApiHandler(
          chattogramDivisionQuery,
          setIsLoading,
          setDashboardCenters,
        );
      }
    }, [apiRefetch, chattogramDivisionQuery]);

    useEffect(() => {
      if (khulnaDivisionQuery.asonId && khulnaDivisionQuery.divisionId) {
        dashboardDivisionAsonCentersApiHandler(
          khulnaDivisionQuery,
          setIsLoading,
          setDashboardCenters,
        );
      }
    }, [apiRefetch, khulnaDivisionQuery]);

    useEffect(() => {
      if (sylhetDivisionQuery?.asonId && sylhetDivisionQuery?.divisionId) {
        dashboardDivisionAsonCentersApiHandler(
          sylhetDivisionQuery,
          setIsLoading,
          setDashboardCenters,
        );
      }
    }, [apiRefetch, sylhetDivisionQuery]);

    useEffect(() => {
      if (
        mymensinghDivisionQuery?.asonId &&
        mymensinghDivisionQuery?.divisionId
      ) {
        dashboardDivisionAsonCentersApiHandler(
          mymensinghDivisionQuery,
          setIsLoading,
          setDashboardCenters,
        );
      }
    }, [apiRefetch, mymensinghDivisionQuery]);

    useEffect(() => {
      if (rajshahiDivisionQuery?.asonId && rajshahiDivisionQuery?.divisionId) {
        dashboardDivisionAsonCentersApiHandler(
          rajshahiDivisionQuery,
          setIsLoading,
          setDashboardCenters,
        );
      }
    }, [apiRefetch, rajshahiDivisionQuery]);

    useEffect(() => {
      if (rangpurDivisionQuery?.asonId && rangpurDivisionQuery?.divisionId) {
        dashboardDivisionAsonCentersApiHandler(
          rangpurDivisionQuery,
          setIsLoading,
          setDashboardCenters,
        );
      }
    }, [apiRefetch, rangpurDivisionQuery]);

    useEffect(() => {
      if (barishalDivisionQuery?.asonId && barishalDivisionQuery?.divisionId) {
        dashboardDivisionAsonCentersApiHandler(
          barishalDivisionQuery,
          setIsLoading,
          setDashboardCenters,
        );
      }
    }, [apiRefetch, barishalDivisionQuery]);

    useEffect(() => {
      const interval = setInterval(() => {
        setApiRefetch((prev) => !prev);
      }, API_REFETCH_TIME * 1000);

      return () => {
        setApiRefetch(false);
        clearInterval(interval);
      };
    }, []);

    return {
      isLoading,
      dashboardCenters,
      handleQuery: cacheHandleQuery,
    };
  };
